var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5390_35969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8467 0C32.0467 0 34.1467 0 36.4333 0.7C38.9067 1.58667 40.8667 3.54667 41.7533 6.02C42.5 8.30667 42.5 10.4533 42.5 14.6533V27.3467C42.5 31.5467 42.5 33.6467 41.8 35.9333C40.9133 38.4067 38.9533 40.3667 36.48 41.2533C34.1467 42 32.0467 42 27.8467 42H15.1533C10.9533 42 8.85333 42 6.56667 41.3C4.04667 40.3667 2.13333 38.4533 1.2 35.9333C0.5 33.6933 0.5 31.5933 0.5 27.3467V14.6533C0.5 10.4533 0.5 8.35333 1.2 6.06667C2.13333 3.59333 4.04667 1.63333 6.56667 0.746667C8.80667 -5.5631e-08 10.9067 0 15.1533 0H27.8467Z",
    fill: "url(#paint0_linear_5390_35969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4526 30.3558C20.2413 30.4685 21.03 30.5436 21.8562 30.5436C28.6916 30.5436 34.25 25.9241 34.25 20.253C34.25 14.5819 28.7291 10 21.8938 10C15.0584 10 9.5 14.6195 9.5 20.2906C9.5 24.0087 11.8661 27.2386 15.3964 29.0413C15.3964 29.154 15.3964 29.2667 15.3964 29.4169C15.3964 30.5061 13.5937 31.9332 13.7064 31.9332C15.5091 31.9332 16.786 30.8065 17.6498 30.5436C18.3634 30.3558 18.7766 30.3183 19.4526 30.3558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_35969",
    x1: 21.4935,
    y1: 0.0130667,
    x2: 21.4935,
    y2: 41.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67FF81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B41F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5390_35969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredMessages);
export default __webpack_public_path__ + "static/media/ic-colored-messages.d4979f8eef2916e199f1679f182738e2.svg";
export { ForwardRef as ReactComponent };